import { SkillCard, SkillCardData } from "src/components/SkillCard";
import classes from "./Skills.module.css";

const skills: SkillCardData[] = [
  {
    title: "AI Tooling",
    skills: [
      "OpenAI",
      { label: "Qdrant", description: "Open-source vector database for high-performance similarity search" },
      { label: "Vector Embeddings", description: "Numerical representations of text/data that capture semantic meaning for ML similarity" },
      { label: "Semantic Search", description: "Relevance search using vector embeddings rather than keyword matching" },
      { label: "OCR Processing", description: "Optical Character Recognition — extracting structured text from scanned images and documents" },
      "Microsoft Foundry",
      "Claude"
    ],
  },
  {
    title: "Architecture",
    skills: [
      "Microservices",
      { label: "Micro-Frontend (MFE)", description: "Architectural pattern decomposing a frontend into independently owned, deployable units per team or domain" },
      // { label: "Module Federation", description: "Webpack feature enabling runtime code sharing across independently deployed micro-frontends" },
      { label: "BFF Pattern", description: "Backend for Frontend — dedicated API layer per client type (web, mobile) to avoid over-fetching" },
      "API Gateway",
      "Serverless",
      // "Event-Driven",
      { label: "RBAC", description: "Role-Based Access Control — permission management using roles and resource-level authorization rules" },
    ],
  },
  {
    title: "Backend & API",
    skills: [
      "Node.js",
      "Typescript",
      "Python",
      "GraphQL",
      "REST",
      ".NET/C#",
      "Payment Gateway Integration",
        "Supabase"
    ],
  },
  {
    title: "Cloud & DevOps",
    skills: [
      "Azure Pipelines",
      "Azure Cloud",
      "AWS Cloud",
      "Docker",
      "CI/CD",
      { label: "Terraform", description: "Infrastructure-as-code tool for provisioning and managing cloud resources declaratively" },
      { label: "Akamai", description: "Edge delivery network providing CDN, WAF, and DDoS mitigation at the network perimeter" },
    ],
  },
  {
    title: "Data Storage",
    skills: [
      "SQL Server",
      "PostgreSQL",
      "Cosmos DB",
      "MongoDB",
      "Object Storages",  
      { label: "Pinecone", description: "Managed vector database service optimized for ML embedding workloads" },
      { label: "pgvector", description: "PostgreSQL extension for storing and querying vector embeddings alongside relational data" },
      "Redis",
    ],
  },
  {
    title: "Frontend & Mobile",
    skills: [
      "React 16+",
      "HTML5",
      "CSS3",
      "TypeScript",
      "React-Native",
      "Android Studio",
      "Xcode",
      "Expo",
    ],
  },
  {
    title: "Observability",
    skills: ["New Relic", "AWS CloudWatch", "Azure Monitor",],
  },
  {
    title: "Project Management",
    skills: ["Azure Devops", "Confluence", "Jira", "Git",],
  },
];

const Skills = () => {
  return (
    <div className={classes["skills-container"]}>
      {skills.map((skillCardData, index) => (
        <SkillCard key={index} {...skillCardData} />
      ))}
    </div>
  );
};

export default Skills;
